/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-undef */
/* eslint-disable no-lone-blocks */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useState, useRef } from 'react';
import S3 from 'react-aws-s3';
import { ThreeDots } from 'react-loader-spinner';
import { uploadFile } from 'react-s3';
import { Uploadconfig } from '../../../../redux/helper/upload-config';

function UploadDocumentModal({
    uploadDocumentModal, setUploadDocumentModal, invoiceNumber, orderNumber, trxNo,
    InputChange, documentDetails, setDocumentDetails, documentNumbers, setDocumentNumbers, handleUploadDoc, handleUploadDocuments, handleDelete, threedotsLoader, setthreedotsLoader, setsubmitSelected, submitSelected, invoiceDetails,
}) {
    const ReactS3Client = new S3(Uploadconfig);
    return (
        <div className={`modal fade fixed top-0 left-0 ${uploadDocumentModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="upload-document" tabIndex="-1" aria-labelledby="addDocumnetation" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative lg:max-w-[500px] lg:min-w-[500px] w-full px-3 pointer-events-none" style={{ margin: 'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col pointer-events-auto w-full bg-white border border-[#707070] bg-clip-padding rounded-md outline-none text-current px-4 pt-3 pb-5">
                    <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative">
                        <h5 className="sm:text-xl text-lg font-semibold leading-normal text-[#090406]" id="exampleModalScrollableLabel">
                            Upload Documents
                        </h5>
                        <button
                            onClick={() => setUploadDocumentModal(false)}
                            type="button"
                            className="absolute top-1 right-1"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            <img src="/images/Icon-ionic-ios-close.svg" alt="icon" />
                        </button>
                    </div>
                    <form>
                        <div className="modal-body pt-[22px]">
                            <div className="flex items-center justify-between px-10">
                                <div>
                                    <p className="font-semibold text-base text-[#555259]">Invoice</p>
                                    <p className="font-normal text-[#090406] text-xs10">{trxNo}</p>
                                </div>
                                <div>
                                    <div className="relative mt-2.5 mb-1 bg-[#44445E] rounded-lg px-[14px] py-3 ml-6 w-[109px] h-8 cursor-pointer">
                                        <input
                                            type="file"
                                            id="invoice"
                                            className="opacity-0 absolute top-0 left-0 cursor-pointer w-[109px]"
                                            onChange={(e) => {
                                                handleUploadDoc(e, 'invoice'); setsubmitSelected(false);
                                            }}

                                        />
                                        <label htmlFor="invoice" className="font-normal text-xs13 text-white absolute left-2.5 top-1 cursor-pointer">+ Attach file</label>
                                    </div>
                                    {submitSelected && documentDetails.invoice === undefined && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1 ml-7">File is required</p>}
                                </div>
                            </div>
                            {documentDetails.invoice
                            && (
                                <div className="flex align-items">
                                    <div className="pr-2">{documentDetails.invoice.split('/')[documentDetails.invoice.split('/').length - 1]}</div>
                                    {' '}
                                    <img
                                        src="/images/circle-close.svg"
                                        alt="icon"
                                        className="pr-4 cursor-pointer"
                                        onClick={() => handleDelete('invoice')}
                                    />
                                </div>
                            )}
                            <div className="flex items-end justify-between mt-5 px-10">
                                <div className=" flex flex-col">
                                    <label htmlFor="eway_bill_number">E-way Bill</label>
                                    <input
                                        type="text"
                                        id="eway_bill_number"
                                        className="border border-[#CECECE] pl-3 rounded py-3 placeholder:font-light placeholder:text-base placeholder:text-[#555259] mt-1.5 outline-0"
                                        placeholder="Enter E-way Bill Number"
                                        onChange={(e) => {
                                            InputChange(e);
                                            setsubmitSelected(false);
                                        }}
                                        value={documentNumbers.eway_bill_number}
                                    />
                                    {submitSelected && documentNumbers.eway_bill_number === '' && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1">Eway Bill number is required</p> }

                                </div>
                                <div>
                                    <div className="relative mt-2.5 mb-1 bg-[#44445E] rounded-lg px-[14px] py-3 ml-6 w-[109px] h-8 cursor-pointer">
                                        <input
                                            type="file"
                                            className="opacity-0 absolute top-0 left-0 cursor-pointer w-[109px]"
                                            onChange={(e) => {
                                                handleUploadDoc(e, 'e_way_bill'); setsubmitSelected(false);
                                            }}
                                            id="e_way_bill"

                                        />
                                        <label htmlFor="e_way_bill" className="font-normal text-xs13 text-white absolute left-2.5 top-1 cursor-pointer">+ Attach file</label>
                                    </div>
                                    {submitSelected && documentDetails.e_way_bill === undefined && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1 ml-7">File is required</p> }
                                </div>

                            </div>
                            {documentDetails.e_way_bill
                            && (
                                <div className="flex align-items">
                                    <div className="pr-2">{documentDetails.e_way_bill.split('/')[documentDetails.e_way_bill.split('/').length - 1]}</div>
                                    {' '}
                                    <img
                                        src="/images/circle-close.svg"
                                        alt="icon"
                                        className="pr-4 cursor-pointer"
                                        onClick={() => handleDelete('e_way_bill')}
                                    />
                                </div>
                            )}

                            <div className="flex items-end justify-between mt-5 px-10">
                                <div className=" flex flex-col">
                                    <label htmlFor="lr_number">LR Copy</label>
                                    <input
                                        type="text"
                                        id="lr_number"
                                        className="border border-[#CECECE] pl-3 rounded py-3 placeholder:font-light placeholder:text-base placeholder:text-[#555259] mt-1.5 outline-0"
                                        placeholder="Enter LR Copy Number"
                                        onChange={(e) => {
                                            InputChange(e);
                                            setsubmitSelected(false);
                                        }}
                                        value={documentNumbers.lr_number}
                                    />
                                    {submitSelected && documentNumbers.lr_number === '' && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1">LR copy number  is required</p> }
                                </div>
                                <div>
                                    <div className="relative mt-2.5 mb-1 bg-[#44445E] rounded-lg px-[14px] py-3 ml-6 w-[109px] h-8 cursor-pointer">
                                        <input
                                            onChange={(e) => {
                                                handleUploadDoc(e, 'lr_copy'); setsubmitSelected(false);
                                            }}
                                            id="lr_copy"
                                            type="file"
                                            className="opacity-0 absolute top-0 left-0 cursor-pointer w-[109px]"
                                        />
                                        <label htmlFor="lr_copy" className="font-normal text-xs13 text-white absolute left-2.5 top-1 cursor-pointer">+ Attach file</label>
                                    </div>
                                    {(submitSelected && documentDetails.lr_copy === undefined) && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1 ml-7">File is required</p> }
                                </div>

                            </div>
                            {documentDetails.lr_copy
                            && (
                                <div className="flex align-items">
                                    <div className="pr-2">{documentDetails.lr_copy.split('/')[documentDetails.lr_copy.split('/').length - 1]}</div>
                                    {' '}
                                    <img
                                        src="/images/circle-close.svg"
                                        alt="icon"
                                        className="pr-4 cursor-pointer"
                                        onClick={() => handleDelete('lr_copy')}
                                    />
                                </div>
                            )}
                            <div className="pt-[22px] flex justify-center">
                                <button
                                    type="submit"
                                    className="w-full py-3 rounded-lg bg-[#555259] text-lg font-semibold upload-document text-[#FFFFFF]"
                                    onClick={(e) => handleUploadDocuments(e, orderNumber, invoiceNumber)}
                                >
                                    {threedotsLoader
                                        ? (
                                            <div style={{ marginLeft: '200px', color: 'white' }}>
                                                <ThreeDots width={50} height={30} color="white" />
                                                {' '}
                                            </div>
                                        ) : 'Upload Documents'}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default UploadDocumentModal;
